module.exports = __webpack_public_path__ + "img/investor_epsilon@2x.5f5ba308.png";